import React, { cloneElement, useCallback } from 'react'
import { styled, SxProps } from '@mui/material/styles'
import {
  FormControl,
  FormHelperText,
  InputLabel,
  InputLabelProps,
} from '@mui/material'

export interface ValidationRuleProps {
  required?: boolean;
  message?: string;
  errorMessage?: string;
  validator?: (value: never) => boolean;
}

export interface FormItemProps {
  text?: string;
  label: string;
  value?: never;
  onChange?: (value: { [key: string]: never }) => void;
  rules?: ValidationRuleProps;
  children: React.ReactElement;
  sx?: SxProps;
  validating?: boolean;
  onValidate?: (error: { [key: string]: boolean }) => void;
  inputLabel?: InputLabelProps;
}

const HelperText = styled(FormHelperText)(() => ({
  marginLeft: 0,
}))

const FromContent = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 'auto',
  width: '100%',
}))

const FormItem: React.FC<FormItemProps> = (props) => {
  const {
    text,
    label,
    value,
    onChange,
    rules,
    children,
    sx,
    validating,
    onValidate,
    inputLabel,
  } = props

     // @ts-ignore
  const { validator, required, message, errorMessage } = rules

  const onFormItemChange = useCallback(
    (value: never) => {
      if (label) {
        if (typeof value === 'object') {
          const event = value as React.ChangeEvent<HTMLInputElement>
          if (event?.target) {
            const inputValue = event?.target?.value as never
               // @ts-ignore
            onChange({ [label]: inputValue })
          } else {
               // @ts-ignore
            onChange({ [label]: value })
          }
        } else {
             // @ts-ignore
          onChange({ [label]: value })
        }
      }
    },
    [label, onChange]
  )

  const validate = (value: never) => {
    const validatorPromise = (value: never) =>
      new Promise<boolean>((resolve) => {
        resolve(validator(value))
      })
    if (validator) {
      validatorPromise(value).then((validationResult: boolean) => {
           // @ts-ignore
        onValidate({ [label]: validationResult })
      })
      return validator(value)
    } else {
         // @ts-ignore
      onValidate({ [label]: true })
      return true
    }
  }

     // @ts-ignore
  const validateResult = validate(value)

  return (
    <FormControl
      sx={{
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginBottom: '16px',
        ...sx,
      }}
    >
      <FromContent>
        {inputLabel && (
          <InputLabel id={`form-item-${text}-label`} {...inputLabel}>
            {text}
          </InputLabel>
        )}
        {cloneElement(children, {
          value,
          onChange: onFormItemChange,
          error: validating && !validateResult,
          label: text,
          required: required,
          labelid: `form-item-${text}-label`,
        })}
        {message && <HelperText sx={{}}>{message}</HelperText>}
        {validating && !validateResult && errorMessage && (
          <HelperText error={true}>{errorMessage}</HelperText>
        )}
      </FromContent>
    </FormControl>
  )
}

export default FormItem
